// Phase 6 — reusable native Material replacement for the AngularJS `ConfirmModal` service
// (components/confirm-modal/ConfirmModal.js, still ng1 — NOT deleted, other screens use it).
//
// Opened via MatDialog with `{ title, message }`; resolves through afterClosed() to `true`
// when the user confirms and `undefined` otherwise:
//   dialog.open(ConfirmDialogComponent, { data: { title, message } })
//     .afterClosed().subscribe(ok => { if (ok) ... });
// Lives under ng/components/ (cross-cutting, like my-switch) so future migrations can reuse it.
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogData {
    title?: string;
    message?: string;
}

@Component({
    selector: 'confirm-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
    private dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
    data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

    confirm(): void {
        this.dialogRef.close(true);
    }

    close(): void {
        this.dialogRef.close();
    }
}
